// Central source of truth for membership tiers across the app.
// Anywhere the UI needs to look up a tier (label, badge colour, default copy),
// import from here — do NOT re-define `membershipConfig` locally.

export const MEMBERSHIP_TIERS = ["foundation", "momentum", "strength", "elite_coaching"];

export const membershipConfig = {
  foundation: {
    label: "Foundation",
    className: "bg-muted text-muted-foreground",
    sidebarClassName: "bg-muted/60 text-sidebar-foreground/50",
  },
  momentum: {
    label: "Momentum",
    className: "bg-sky-500/10 text-sky-400",
    sidebarClassName: "bg-sky-500/20 text-sky-400",
  },
  strength: {
    label: "Strength",
    className: "bg-orange-500/10 text-orange-400",
    sidebarClassName: "bg-orange-500/20 text-orange-400",
  },
  elite_coaching: {
    label: "Elite Coaching",
    className: "bg-amber-400/10 text-amber-300",
    sidebarClassName: "bg-amber-400/20 text-amber-300",
  },
};

// Map legacy enum values that may still be in the DB or arrive from external
// callers. Keeps the UI from crashing while data is being migrated.
const LEGACY_MAP = {
  free: "foundation",
  basic: "momentum",
  premium: "strength",
  trainer: "elite_coaching",
};

export const normaliseTier = (tier) => {
  if (!tier) return "foundation";
  const t = String(tier).toLowerCase();
  if (membershipConfig[t]) return t;
  if (LEGACY_MAP[t]) return LEGACY_MAP[t];
  return "foundation";
};

export const formatMembership = (membership) =>
  membershipConfig[normaliseTier(membership)].label;

export const getMembershipConfig = (membership) =>
  membershipConfig[normaliseTier(membership)];

// Highest tier first — used by upgrade prompts / pricing pages later.
export const TIER_ORDER = MEMBERSHIP_TIERS;
export const isPaidTier = (membership) => normaliseTier(membership) !== "foundation";
